var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEditCommentFillNaDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "#C6C8CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0762 24.3533L8.667 25.3333L9.647 20.9241C9.00161 19.7169 8.66494 18.3688 8.667 17C8.667 12.3975 12.3978 8.66663 17.0003 8.66663C21.6028 8.66663 25.3337 12.3975 25.3337 17C25.3337 21.6025 21.6028 25.3333 17.0003 25.3333C15.6315 25.3354 14.2833 24.9987 13.0762 24.3533ZM13.3178 22.5925L13.862 22.8841C14.8275 23.4001 15.9057 23.6689 17.0003 23.6666C18.3189 23.6666 19.6078 23.2756 20.7041 22.5431C21.8005 21.8105 22.6549 20.7694 23.1595 19.5512C23.6641 18.333 23.7961 16.9926 23.5389 15.6994C23.2817 14.4062 22.6467 13.2183 21.7144 12.2859C20.782 11.3536 19.5941 10.7186 18.3009 10.4614C17.0077 10.2042 15.6673 10.3362 14.4491 10.8408C13.2309 11.3453 12.1897 12.1998 11.4572 13.2962C10.7247 14.3925 10.3337 15.6814 10.3337 17C10.3337 18.1116 10.6045 19.1816 11.117 20.1383L11.4078 20.6825L10.862 23.1383L13.3178 22.5925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditCommentFillNaDisabled);
export default __webpack_public_path__ + "static/media/ic_edit_comment_fill_na_disabled.eb139ab2a7d712a6616114ef69fc4f48.svg";
export { ForwardRef as ReactComponent };